import { Injectable } from "@angular/core";

interface PrizesRow {
    prize: number;
    amount: number;
}

export interface PrizesTable {
    name: string;
    prizes: PrizesRow[];
}

@Injectable({ providedIn: "root" })
export class PrizesService {
    private prizes = [
        { prize: 60000, amount: 9000 },
        { prize: 120000, amount: 15000 },
        { prize: 260000, amount: 50 },
        { prize: 1000000, amount: 50 },
        { prize: 2000000, amount: 15 },
        { prize: 5000000, amount: 15 },
        { prize: 15000000, amount: 15 },
        { prize: 118000000, amount: 14 },
        { prize: 300000000, amount: 1 }
    ];

    private prizesTable: PrizesTable[] = [
        { name: "1/8", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 8), amount: amount })) },
        { name: "1/4", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 4), amount: amount })) },
        { name: "1/2", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 2), amount: amount })) },
        { name: "1/1", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 1), amount: amount })) },
        { name: "3/2", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (3 / 2), amount: amount })) },
        { name: "Tripelpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (3 / 2), amount: amount })) },
        { name: "Dobbeltpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 1), amount: amount })) },
        { name: "Millionpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 2), amount: amount })) },
        { name: "Halvpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 4), amount: amount })) },
        { name: "Kvartpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 8), amount: amount })) },
        { name: "Millionærpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (3 / 2), amount: amount })) },
        { name: "Favoritpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 1), amount: amount })) },
        { name: "Startpakken", prizes: this.prizes.map(({ prize, amount }) => ({ prize: prize * (1 / 2), amount: amount })) },
    ];

    public getPrizesTable(): PrizesTable[] {
        return this.prizesTable;
    }
}
